export var BlueprintDrawingType;
(function (BlueprintDrawingType) {
    BlueprintDrawingType["Polyline"] = "polyline";
    BlueprintDrawingType["Polygon"] = "polygon";
    BlueprintDrawingType["Circle"] = "circle";
    BlueprintDrawingType["TextAnnotation"] = "annotation";
    BlueprintDrawingType["MeasurementLabel"] = "measurement";
})(BlueprintDrawingType || (BlueprintDrawingType = {}));
export var BlueprintDrawingStyle;
(function (BlueprintDrawingStyle) {
    BlueprintDrawingStyle["StrokeColor"] = "strokeColor";
    BlueprintDrawingStyle["StrokeWidth"] = "strokeWidth";
    BlueprintDrawingStyle["StrokeStyle"] = "strokeStyle";
    BlueprintDrawingStyle["FillColor"] = "fillColor";
    BlueprintDrawingStyle["TextColor"] = "textColor";
    BlueprintDrawingStyle["TextSize"] = "textSize";
    BlueprintDrawingStyle["TextOffset"] = "textOffset";
})(BlueprintDrawingStyle || (BlueprintDrawingStyle = {}));
export var BlueprintPolygonSubtype;
(function (BlueprintPolygonSubtype) {
    BlueprintPolygonSubtype["Polygon"] = "polygon";
    BlueprintPolygonSubtype["Rectangle"] = "rectangle";
})(BlueprintPolygonSubtype || (BlueprintPolygonSubtype = {}));
